import {
  SubPageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { Content } from '@backstage/core-components';
import { UserSettingsAppearanceCard } from '@backstage/plugin-user-settings';
import Grid from '@material-ui/core/Grid';
import { KsdpProfileCard } from './KsdpProfileCard';

/**
 * Replaces the built-in "General" tab of the Settings page
 * (`sub-page:user-settings/general`, same kind and name, so it overrides it).
 *
 * The built-in tab also renders the "Backstage Identity" card, whose links
 * open the catalog's User and Group entity pages. KSDP users should not land
 * there, so this version leaves that card out. The user's access groups are
 * shown as plain text on the Profile card instead (see KsdpProfileCard).
 */
const generalSettingsPage = SubPageBlueprint.make({
  name: 'general',
  params: {
    path: 'general',
    title: 'General',
    loader: async () => (
      <Content>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} md={6}>
            <KsdpProfileCard />
          </Grid>
          <Grid item xs={12} md={6}>
            <UserSettingsAppearanceCard />
          </Grid>
        </Grid>
      </Content>
    ),
  },
});

export const settingsModule = createFrontendModule({
  pluginId: 'user-settings',
  extensions: [generalSettingsPage],
});
